import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Main from "./components/Main/Main";
import Home from "./components/Home";
import About from "./components/About";
import Privacy from "./components/Privacy";
import Projects from "./components/Projects";
import {BlogArticle, Blog} from "./components/Blog";
import NotFound from "./components/NotFound";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Main/>,
        children: [
            {
                path: "/",
                element: <Home/>
            },
            {
                path: "/projects",
                element: <Projects/>
            },
            // {
            //     path: "/blog",
            //     element: <Blog/>
            // },
            // {
            //     path: "/blog/:id",
            //     element: <BlogArticle/>
            // },
            {
                path: "/about",
                element: <About/>
            },
            {
                path: "*",
                element: <NotFound/>
            }
        ]
    },
    {
        path: "/privacy-application",
        element: <Privacy/>
    },
    {
        path: "*",
        element: <NotFound/>
    }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router}/>
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
